import _ from 'underscore';

import {ProcessesFeature} from 'auth/capabilities/CapabilityFeatureConstants';
import {isFeatureEnabled} from 'auth/feature-enablement/FeatureStatus';
import BenchlingConfig from 'BenchlingConfig';
import CalendarActions from 'calendar/CalendarActions';
import {CalendarPartyOptions, CalendarView, ViewRange} from 'calendar/CalendarConstants';

export function calendarDidMount(
  viewRange: ViewRange,
  currentView: CalendarView,
  partyArgs: CalendarPartyOptions = {}
): void {
  // Prevent dispatch within dispatch
  _.defer(() => {
    // Prevent modal from showing up in case it was open before
    CalendarActions.deselectCalendarItem();

    const [viewStart, viewEnd] = viewRange;
    CalendarActions.fetchEntries(viewStart, viewEnd, partyArgs);
    if (BenchlingConfig.ENABLE_REQUESTS) {
      CalendarActions.fetchRequests(viewStart, viewEnd, partyArgs);
    }
    if (isFeatureEnabled({feature: ProcessesFeature.PROCESSES_SHOW_DETAILS})) {
      CalendarActions.fetchProcessTasks(viewStart, viewEnd, partyArgs);
    }
    if (currentView !== CalendarView.MONTH_VIEW) {
      CalendarActions.fetchFiles(viewStart, viewEnd, partyArgs);
    }
  });
}

export function calendarDidUpdate(
  previousViewRange: ViewRange,
  viewRange: ViewRange,
  previousCurrentView: CalendarView,
  currentView: CalendarView,
  partyArgs: CalendarPartyOptions = {}
): void {
  const [prevViewStart, prevViewEnd] = previousViewRange;
  const [viewStart, viewEnd] = viewRange;
  const viewRangeChanged = !prevViewStart.isSame(viewStart) || !prevViewEnd.isSame(viewEnd);
  if (viewRangeChanged) {
    // Since update may be caused by store update during action dispatch, we _.defer to avoid dispatching
    // action within an action.
    _.defer(() => {
      CalendarActions.fetchEntries(viewStart, viewEnd, partyArgs);
    });
  }
  if (viewRangeChanged && BenchlingConfig.ENABLE_REQUESTS) {
    _.defer(() => {
      CalendarActions.fetchRequests(viewStart, viewEnd, partyArgs);
    });
  }
  if (viewRangeChanged && isFeatureEnabled({feature: ProcessesFeature.PROCESSES_SHOW_DETAILS})) {
    _.defer(() => {
      CalendarActions.fetchProcessTasks(viewStart, viewEnd, partyArgs);
    });
  }
  const viewChanged = previousCurrentView !== currentView;
  if ((viewRangeChanged || viewChanged) && currentView !== CalendarView.MONTH_VIEW) {
    _.defer(() => {
      CalendarActions.fetchFiles(viewStart, viewEnd, partyArgs);
    });
  }
}
